export enum UserStatus {
    LOGGED_IN = 'loggedin',
    LOGGED_OUT = 'loggedout',
    DISCONNECTED = 'disconnected',
    ERROR = 'error',
}
